module.exports = __webpack_public_path__ + "static/media/material_icon_expand.697e1143.svg";